import React, { useEffect, useState } from "react";
import Navbar from "../components/comman/Navbar";
import Footer from "../components/comman/Footer";
import { fetchLiveStreams } from "../services/operations/admin";
import Seo from "../components/comman/Seo";
import { SITE_NAME } from "../constant/site";

function Live() {
  const [liveStreams, setLiveStreams] = useState([]);

  useEffect(() => {
    const fetchStreams = async () => {
      try {
        const response = await fetchLiveStreams();
        setLiveStreams(response || []);
      } catch (error) {
        console.error("Error fetching live streams:", error);
      }
    };

    fetchStreams();
  }, []);

  return (
    <div>
      <Seo
        title="Live News"
        description={`Watch live news updates and breaking coverage from ${SITE_NAME}.`}
        keywords={["live news", "breaking news", `${SITE_NAME} live`]}
        url="/live"
      />
      <Navbar />

      <div className="mt-20 min-h-screen flex justify-center items-center">
        {liveStreams.length === 0 ? (
          <div className="text-center">Currently No Live Streaming Is Available</div>
        ) : (
          <div className="grid gap-4">
            {liveStreams.map((stream) => (
              <div key={stream._id} className="bg-white p-4 rounded-lg shadow">
                <div className="flex justify-between">
                  <h2 className="text-xl font-semibold">{stream.name}</h2>
                </div>
                <div className="mt-2">
                  <iframe
                    className="w-[90vw] h-[80vh]"
                    src={`${stream.url}?autoplay=1`}
                    title={stream.name}
                    frameBorder="0"
                    allow="autoplay; encrypted-media"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}

export default Live;